import LinkedinProfile from "./LinkedinProfile";

export default LinkedinProfile;
